import { ThunkAction } from 'components/redux/types/ThunkAction';
import { MenuId } from 'moduleBase/modules/menu/types/MenuId';
import {
  MENU_MAIN_LOAD_CHANNELS_URL,
  MENU_MAIN_LOAD_DYNAMIC_SUB_MENU_COMPLETE,
  MENU_MAIN_LOAD_PROJECTS_URL, MENU_MAIN_LOAD_SUB_MENU_COMPLETE,
} from 'moduleBase/modules/menu/constants';
import { MenuItem } from 'moduleBase/types/Menu';
import { FSAWithPayload } from '@collaborator/npm_modules/dist/components/redux';
import {
  LoadDynamicSubMenuCompletePayloadType,
} from 'moduleBaseMenu/actions/types/LoadDynamicSubMenuCompletePayloadType';
import { LoadDynamicSubMenuResponseType } from 'moduleBaseMenu/actions/types/LoadDynamicSubMenuResponseType';
import { ApiError } from '@collaborator/npm_modules/dist/modules/base/errors/ApiError';
import { LoadSubMenuResponseType } from 'moduleBaseMenu/actions/types/LoadSubMenuResponseType';
import { LoadSubMenuCompletePayloadType } from 'moduleBaseMenu/actions/types/LoadSubMenuCompletePayloadType';

const menuMainLoadDynamicSubMenuComplete = (
  id: MenuId,
  items: MenuItem[],
): FSAWithPayload<LoadDynamicSubMenuCompletePayloadType> => ({
  type: MENU_MAIN_LOAD_DYNAMIC_SUB_MENU_COMPLETE,
  payload: {
    id,
    items,
  },
});

const menuMainLoadDynamicSubMenu = (id: MenuId, url: string, query = {}): ThunkAction => (
  dispatch,
  getState,
  { networkService },
) => networkService.get<LoadDynamicSubMenuResponseType>(url, {
  params: query,
}).then((response) => {
  dispatch(menuMainLoadDynamicSubMenuComplete(id, response.data.items));
}).catch((error: ApiError | Error) => {
  if (error instanceof ApiError && error.status === 404) {
    return;
  }
  throw error;
});

const menuMainLoadSubMenuComplete = (
  id: MenuId,
  items: MenuItem[],
): FSAWithPayload<LoadSubMenuCompletePayloadType> => ({
  type: MENU_MAIN_LOAD_SUB_MENU_COMPLETE,
  payload: {
    id,
    items,
  },
});

const menuMainLoadSubMenu = (id: MenuId, url: string, query = {}): ThunkAction => (
  dispatch,
  getState,
  { networkService },
) => networkService.get<LoadSubMenuResponseType>(url, {
  params: query,
}).then((response) => {
  dispatch(menuMainLoadSubMenuComplete(id, response.data.items));
}).catch((error: ApiError | Error) => {
  if (error instanceof ApiError && error.status === 404) {
    return;
  }
  throw error;
});

const menuMainLoadProjects = (
  id: number | null = null,
) => {
  const query = id ? { id } : null;
  return menuMainLoadDynamicSubMenu(MenuId.myProjects, MENU_MAIN_LOAD_PROJECTS_URL, query);
};

const menuMainLoadChannels = () => menuMainLoadSubMenu(MenuId.myChannels, MENU_MAIN_LOAD_CHANNELS_URL);

export { menuMainLoadProjects, menuMainLoadChannels };
